import axios from 'axios'
import { getConfigForNetwork } from '../utils'
const config = getConfigForNetwork()

export default {
  namespaced: true,
  state: {
    access_token: undefined,
    expires_in: undefined,
    refresh_token: undefined,
    scope: undefined,
    session_token: undefined,
    token_type: undefined,
    expired_time: undefined
  },
  mutations: {
    updateState (state, payload) {
      console.log(payload)
      for (let key in payload) {
        if (payload.hasOwnProperty(key)) {
          state[key] = payload[key]
        }
      }
    }
  },
  actions: {
    restoreToken ({ commit }) {
      const appTokenString = localStorage.getItem('app_token')
      if (appTokenString) {
        const appTokenJSON = JSON.parse(appTokenString)
        commit('updateState', appTokenJSON)
      }
    },
    setNewAppToken ({ commit }, appTokenJSON) {
      // Calculate expires time unix
      const expiredTime = Date.now() + (3600 * 1000)
      appTokenJSON.expired_time = expiredTime
      // Set to localStorage & update into store
      const appTokenString = JSON.stringify(appTokenJSON)
      localStorage.setItem('app_token', appTokenString)
      commit('updateState', appTokenJSON)
    },
    async getAppTokenByCode ({ dispatch }, payload) {
      try {
        const result = await axios.post(`${config.backendURL}/auth/login`, {
          code: payload
        })
        if (result.data) {
          dispatch('setNewAppToken', result.data)
        }
      } catch (e) {
        console.log(e.response)
      }
    },

    async refreshAppToken ({ state, dispatch }) {
      try {
        const result = await axios.post(`${config.backendURL}/auth/refresh_token`, {
          refresh_token: state.refresh_token
        })
        if (result.data) {
          dispatch('setNewAppToken', { ...state, ...result.data })
        }
      } catch (e) {
        console.log(e.response)
      }
    }
  },
  getters: {
    isTokenExpired (state) {
      return Date.now() > new Date(state.expired_time)
    }
  }
}
